import { _ } from 'vue-underscore';

export default {
    data() {
        return {
            query: null,
            result: []
        }
    },
    watch: {
        query() {
            if (this.query && this.query.length < 2) {
                this.result = [];
                return;
            }
            this.dsearch();
        }
    },
    methods: {
        submitForm(e) {
            if (!this.query || this.query.trim() === '') {
                e.preventDefault();
                this.$refs.searchInput.focus();
                return false;
            }
            return true;
        },
        handleInputFocus() {
            // Hide buttons outside of this component when input gets focus
            const hideButtons = document.querySelectorAll('.hide-button');
            hideButtons.forEach(button => {
                button.style.display = 'none';
            });
        },
        handleInputBlur() {
            // Show buttons again when input loses focus
            const hideButtons = document.querySelectorAll('.hide-button');
            hideButtons.forEach(button => {
                button.style.display = '';
            });
        },
        search() {
            if (!this.query) {
                this.result = [];
                return;
            }
            this.$http.post('/catalog/quick-search', {'query': this.query, 'max_result_count': 100}).then(response => {
                this.result = response.data
            })
        },
        dsearch: _.debounce(function () {
            this.search()
        }, 500)
    }
}